import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "../../i18n";

export const Properties = () => {
  const { t } = useLang();
  const props = [
    { n: "01", t: t("pp.t1"), d: t("pp.d1") },
    { n: "02", t: t("pp.t2"), d: t("pp.d2") },
    { n: "03", t: t("pp.t3"), d: t("pp.d3") },
    { n: "04", t: t("pp.t4"), d: t("pp.d4") },
  ];

  return (
    <section id="proprieta" data-testid="properties-section" className="bg-[#F3EFE6] py-24 lg:py-40 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <Reveal><Eyebrow>{t("pp.eyebrow")}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#1C1917]">
              {t("pp.h2a")} <em className="text-[#9A4930]">{t("pp.h2em")}</em> {t("pp.h2b")}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-base md:text-lg text-[#57534E] leading-relaxed">{t("pp.p")}</p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-12 aspect-[4/3] overflow-hidden">
              <img src="/img/sorting.jpg" alt="Selezione dei capi tessili" loading="lazy" decoding="async" className="w-full h-full object-cover grayscale-[30%] hover:grayscale-0 transition-[filter] duration-1000" />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7 lg:pt-24">
          {props.map((p, i) => (
            <Reveal key={p.n} delay={0.08 * i}>
              <div
                data-testid={`property-${p.n}`}
                className="group grid grid-cols-[auto_1fr] gap-6 sm:gap-10 py-8 lg:py-10 border-t border-[#D9D0C1] last:border-b cursor-default"
              >
                <span className="font-mono text-xs text-[#9A4930] pt-3">{p.n}</span>
                <div>
                  <h3 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-[#1C1917] transition-transform duration-700 group-hover:translate-x-4">
                    {p.t}
                  </h3>
                  <p className="mt-2 text-sm md:text-base text-[#57534E]">{p.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
